import { Skeleton } from 'primitives/skeleton'

interface SkeletonFiltersProps {
  searchableColumnCount: number
  filterableColumnCount: number
  showViewOptions: boolean
}

export const SkeletonFilters = ({
  searchableColumnCount,
  filterableColumnCount,
  showViewOptions,
}: SkeletonFiltersProps) => (
  <div className="flex w-full items-center justify-between space-x-2 overflow-auto p-1">
    <div className="flex flex-1 items-center space-x-2">
      {searchableColumnCount > 0
        ? Array.from({ length: searchableColumnCount }).map((_, i) => (
            <Skeleton key={i} className="h-7 w-40 lg:w-60" />
          ))
        : null}
      {filterableColumnCount > 0
        ? Array.from({ length: filterableColumnCount }).map((_, i) => (
            <Skeleton key={i} className="h-7 w-[4.5rem]" />
          ))
        : null}
    </div>
    {showViewOptions ? <Skeleton className="ml-auto hidden h-7 w-[4.5rem] lg:flex" /> : null}
  </div>
)
